import { cn } from "@/lib/utils";

const SHOWCASE_META = {
  posters: {
    accent: "#ff7a45",
    accentSoft: "rgba(255, 122, 69, 0.28)",
    accentAlt: "#15c7b8",
    accentAltSoft: "rgba(21, 199, 184, 0.24)",
    frameLabel: "Live board",
    panelA: "Daily offers",
    panelB: "Story stack",
    pills: ["Status", "Offers", "Carousel"],
  },
  identity: {
    accent: "#ff8f5a",
    accentSoft: "rgba(255, 143, 90, 0.28)",
    accentAlt: "#36c5ff",
    accentAltSoft: "rgba(54, 197, 255, 0.24)",
    frameLabel: "Brand + motion",
    panelA: "Reel covers",
    panelB: "Launch kit",
    pills: ["Reels", "Logo", "Cards"],
  },
  ads: {
    accent: "#f97352",
    accentSoft: "rgba(249, 115, 82, 0.28)",
    accentAlt: "#22d3ee",
    accentAltSoft: "rgba(34, 211, 238, 0.24)",
    frameLabel: "Campaign board",
    panelA: "Ad setup",
    panelB: "Profile PDF",
    pills: ["Ads", "Profile", "CTA"],
  },
  monthly: {
    accent: "#ff8a3d",
    accentSoft: "rgba(255, 138, 61, 0.28)",
    accentAlt: "#18c1a3",
    accentAltSoft: "rgba(24, 193, 163, 0.24)",
    frameLabel: "Recurring system",
    panelA: "Content flow",
    panelB: "Monthly plan",
    pills: ["Planner", "Growth", "Always-on"],
  },
  industry: {
    accent: "#ff8a3d",
    accentSoft: "rgba(255, 138, 61, 0.28)",
    accentAlt: "#b784ff",
    accentAltSoft: "rgba(183, 132, 255, 0.24)",
    frameLabel: "Industry packs",
    panelA: "Vertical mix",
    panelB: "Pack ladder",
    pills: ["Clinic", "Salon", "Food"],
  },
};

function MicroPanel({ label, tone = "primary" }) {
  return (
    <div className={`package-showcase__micro package-showcase__micro--${tone}`}>
      <div className="package-showcase__micro-top">
        <span className="package-showcase__micro-dot" />
        <span className="package-showcase__micro-line package-showcase__micro-line--short" />
      </div>
      <div className="package-showcase__micro-bars">
        <span className="package-showcase__micro-bar package-showcase__micro-bar--tall" />
        <span className="package-showcase__micro-bar package-showcase__micro-bar--mid" />
        <span className="package-showcase__micro-bar package-showcase__micro-bar--small" />
      </div>
      <div className="package-showcase__micro-copy">
        <span className="package-showcase__micro-line" />
        <span className="package-showcase__micro-line package-showcase__micro-line--mid" />
        <span className="package-showcase__micro-label">{label}</span>
      </div>
    </div>
  );
}

export default function PackageShowcaseArt({
  image,
  variant = "posters",
  layout = "wide",
  className,
}) {
  const meta = SHOWCASE_META[variant] || SHOWCASE_META.posters;

  return (
    <div
      className={cn(
        "package-showcase",
        `package-showcase--${variant}`,
        `package-showcase--${layout}`,
        className,
      )}
      style={{
        "--showcase-accent": meta.accent,
        "--showcase-accent-soft": meta.accentSoft,
        "--showcase-accent-alt": meta.accentAlt,
        "--showcase-accent-alt-soft": meta.accentAltSoft,
      }}
    >
      <div className="package-showcase__grid" />
      <div className="package-showcase__beam package-showcase__beam--orange" />
      <div className="package-showcase__beam package-showcase__beam--cyan" />
      <div className="package-showcase__orb package-showcase__orb--orange" />
      <div className="package-showcase__orb package-showcase__orb--cyan" />
      <div className="package-showcase__frame package-showcase__frame--secondary">
        <MicroPanel label={meta.panelA} tone="primary" />
      </div>
      <div className="package-showcase__frame package-showcase__frame--tertiary">
        <MicroPanel label={meta.panelB} tone="secondary" />
      </div>
      <div className="package-showcase__frame package-showcase__frame--primary">
        <span className="package-showcase__frame-label">{meta.frameLabel}</span>
        <img src={image} alt="" loading="lazy" className="package-showcase__board" />
      </div>
      {meta.pills.map((pill, index) => (
        <span
          key={pill}
          className={`package-showcase__pill package-showcase__pill--${index + 1}`}
        >
          {pill}
        </span>
      ))}
    </div>
  );
}
